// Auth Actions Types 

export const UPDATE_CHANGES='UPDATE_CHANGES'